
export default function LastEvent(query, span = 'since ts 0') {
    const S = require('live/services/subscription')
    const subscriber = new S()

    return new Promise((Resolve, Reject) => {
        subscriber.close()
        subscriber
            .request({
                follow: false,
                span: span,
                expression:'__spread_sheet_control\
                =>@set (timestamp()):dateformat("dd/MM/YYYY | hh:mm") as date\
                =>@set (origin):jsonparse()->user as user\
                => map(collection, (uid, user, timestamp, date)) as batch at the end'
                    // '__spread_sheet_control \
                    // => uid, origin:jsonparse() as origin, timestamp by collection at the end \
                    // =>@set (timestamp()):dateformat("dd/MM/YYYY | hh:mm", "UTC") as date'
            })
            // .on('span', () => batch = [])
            .on('event', events => {
                // batch.push(events)
                if (typeof events === 'object' && events !== null) {
                    Resolve(events[0].batch)
                } else {
                    Reject({})
                }
            })
            .on('endHistory', events => {
                // if (Array.isArray(batch)) {
                //     Resolve(batch)
                // } else {
                //     Reject([])
                // }
            })

        subscriber.flush()
    })

}
